/**
 * reducers/orders.ts
 * desc: client orders
 * note: connects to third-party systems via Y Meadows API endpoints
 *
 */

import type { Reducer } from '@reduxjs/toolkit';
import type { OrdersAction } from '../actions/orders';
import type { OrderInfoDto, OrderInfoPage } from '../../types/api/orders';
import type { PageInfo } from '../../types/api/paging';

// empty until the first page arrives
export type OrdersPagination = Partial<PageInfo> & { asOf?: string };

export interface OrdersState {
    isLoading: {
        getOrders: boolean;
    };
    list: OrderInfoDto[];
    pagination: OrdersPagination;
}

const INITIAL_STATE: OrdersState = {
    isLoading: {
        getOrders: false,
    },
    list: [],
    pagination: {}
};


function ordersReducer(state: OrdersState = INITIAL_STATE, action: OrdersAction): OrdersState {
    switch (action.type) {
        // GET Orders
        case 'GET_ORDERS_ERROR':
            return _getOrdersError(state);
        case 'GET_ORDERS_REQUEST':
            return _getOrdersRequest(state);
        case 'GET_ORDERS_SUCCESS':
            return _getOrdersSuccess(state, action.payload);

        default:
            return state;
    }
}



//*************************************************
//*****   GET Orders                     **********
//*************************************************
function _getOrdersError(state: OrdersState): OrdersState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getOrders: false,
        },
    };
}

function _getOrdersRequest(state: OrdersState): OrdersState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getOrders: true,
        },
    };
}

function _getOrdersSuccess(state: OrdersState, payload: OrderInfoPage): OrdersState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getOrders: false,
        },
        list: payload.ordersInfo,
        pagination: {
            asOf: payload.asOf,
            ...payload.page
        },
    };
}

export default ordersReducer as Reducer<OrdersState>;
